'use strict';

import defaultTemplate from '../../core/default.html';
import notificationsListTemplate from './notifications.list.html';
import notificationsInfoTemplate from './notifications.info.html';
import notificationGroupsTemplate from './groups/notificationGroups.html';

import Notifications from './notifications.ctrl';

function NotificationsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.notifications', {
      url: '/notifications',
      template: defaultTemplate,
      // NOTE: Disabled due to CC-1123
      // We need to rewrite logic so when we select location/device/user item in another organization - we need to change current org to organization of that item
      // resolve: {
      // // Feature 'n' is only for notifications module access
      // permission: ($q, utils) => {
      //   const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
      //   let orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
      //   let hasFeatureN = utils.hasFeature(orgInfo, 'n');
      //   return hasFeatureN ? $q.resolve() : $q.reject('Current organization has no Notifications feature');
      // }
      // }
    })
    .state('main.notifications.list', {
      url: '/list',
      template: notificationsListTemplate,
      controller: 'NotificationsListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewNotificationList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.notifications.list');
        },
      },
      params: {
        highlight: null
      }
    })
    .state('main.notifications.info', {
      url: '/info?:tab?:from?:locationId?:timezone',
      template: notificationsInfoTemplate,
      controller: 'NotificationsInfoController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIEditNotification()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.notifications.info');
        }
      }
    });
}

export default angular
  .module('notifications.router', [
    Notifications
  ])
  .config(NotificationsRouter)
  .name;
